import { gql } from '@apollo/client';

export const INSERT_CONTINUE_WATCHING = gql`
  mutation insertContinueWatching($input: InsertContinueWatchingInput!) {
    insertContinueWatching(input: $input) {
      message
    }
  }
`;

export const REMOVE_CONTINUE_WATCHING = gql`
  mutation removeContinueWatching($jwMediaId: String!) {
    removeContinueWatching(jwMediaId: $jwMediaId) {
      message
    }
  }
`;

export interface InsertContinueWatchingInput {
  jwMediaId: string;
  watchedPosition: number;
}
